import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ai-restricted-popover',
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  template: `
    <div class="credit-alert-popover">
      <div class="popover-header">
        <mat-icon class="popover-icon">lock</mat-icon>
        <span class="popover-title">{{ 'AiRestrictedAlert.Title' | translate }}</span>
      </div>
      <p class="popover-message">{{ 'AiRestrictedAlert.Message' | translate }}</p>
    </div>
  `,
  styles: [
    `
      .credit-alert-popover {
        padding: 16px;
        width: 240px;
        background: var(--skz-background-color-surface, #ffffff);
        border: 1px solid var(--skz-border-color-main, rgba(226, 232, 240, 0.8));
        border-radius: var(--skz-radius-medium, 12px);
        box-shadow: var(--skz-box-shadow-light, 0 4px 12px rgba(0, 0, 0, 0.08));
        animation: 
          popover-enter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), 
          popover-flicker 2s ease-out,
          popover-shake 0.4s ease-in-out 0.35s,
          popover-border-glow 3s ease-out;
      }

      @keyframes popover-enter {
        from { opacity: 0; transform: scale(0.92) translateY(6px); }
        to { opacity: 1; transform: scale(1) translateY(0); }
      }

      @keyframes popover-flicker {
        0%, 100% { background: var(--skz-background-color-surface, #ffffff); }
        10%, 30%, 50% { background: rgba(90, 115, 197, 0.08); }
        20%, 40%, 60% { background: var(--skz-background-color-surface, #ffffff); }
      }

      @keyframes popover-shake {
        0%, 100% { transform: translateX(0); }
        25% { transform: translateX(-4px); }
        75% { transform: translateX(4px); }
      }

      @keyframes popover-border-glow {
        0% { border-color: var(--primary, #5a73c5); box-shadow: var(--skz-box-shadow-light, 0 4px 12px rgba(0, 0, 0, 0.08)), 0 0 8px rgba(90, 115, 197, 0.3); }
        40% { border-color: var(--primary, #5a73c5); box-shadow: var(--skz-box-shadow-light, 0 4px 12px rgba(0, 0, 0, 0.08)), 0 0 6px rgba(90, 115, 197, 0.2); }
        100% { border-color: var(--skz-border-color-main, rgba(226, 232, 240, 0.8)); box-shadow: var(--skz-box-shadow-light, 0 4px 12px rgba(0, 0, 0, 0.08)); }
      }

      .popover-header {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 8px;
      }

      .popover-icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
        color: var(--primary, #5a73c5);
        animation: icon-bounce 2s infinite;
      }

      @keyframes icon-bounce {
        0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
        40% {transform: translateY(-3px);}
        60% {transform: translateY(-1.5px);}
      }

      .popover-title {
        font-size: 13px;
        font-weight: 700;
        color: var(--skz-text-primary, #0f172a);
      }

      .popover-message {
        font-size: 12px;
        line-height: 1.5;
        color: var(--skz-text-muted, #64748b);
        margin: 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiRestrictedPopoverComponent {}
